import { AlarmTypeGroupRequestDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateAlarmTypeGroupDetails(
  alarmTypeGroupId: number,
  onSuccess: () => void
) {
  const url = `/v2/orm/alarmtype_groups/${alarmTypeGroupId}`;

  const request = new Request(url, {
    method: 'PUT',
  });

  return useAuthenticatedMutation<null, AlarmTypeGroupRequestDTO>(request, {
    onSuccessInvalidationKeys: [['alarm-type-groups']],
    onSuccess,
  });
}

export default useUpdateAlarmTypeGroupDetails;
